import * as React from 'react';
import { Node } from 'slate';

import { ELEMENT_HOVER_CARD } from './defaults';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const HoverCardElement = withDynamicBlogEditorPluginHydration({ canInteract: true })(dynamicEditorComponent(() =>
  import('./components/HoverCardElement').then((mod) => mod.HoverCardElement),
));

export const renderHoverCardElement =
  (options) =>
    ({ attributes, children, element }) => {
      const { isReadOnly } = options;
      if (element.type === ELEMENT_HOVER_CARD) {
        const isEmptyHoverContent = !Node.string({ children: element.hoverContent || [] });

        if (isEmptyHoverContent && isReadOnly) {
          return <span>{children}</span>;
        }

        return (
        <HoverCardElement
          {...element}
          {...attributes}
          {...options}
          isEmptyHoverContent={isEmptyHoverContent}
        >
          {children}
        </HoverCardElement>
        );
      }
      return null;
    };
